import { css } from '@linaria/core';
import CheckedIcon from './../icons/Checked';
import UncheckedIcon from './../icons/Unchecked';
import { useEffect, useState } from 'react';

const wrapper = css`
  cursor: pointer;
  display: flex;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 20px;
  gap: 15px;
  align-items: center;
`;

const input = css`
  cursor: inherit;
  position: relative;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1;
`;

const iconWrapper = css`
  border-radius: 5px;
  cursor: pointer;
  line-height: 0;
  height: fit-content;

  &:focus-within {
    box-shadow:
      0 0 0 3px #fd0,
      inset 0 0 0 3px #1a1a1a;
  }
`;

const icon = css`
  width: 30px;
  height: 30px;
  fill: #000;
`;

const countStyle = css`
  border-radius: 5px;
  font-size: 16px;
  padding: 3px 5px;
  background: #d1e1fb;
  color: #1a1a1a;
  margin-left: 10px;
`;

const labelWrapper = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default function FormCheckbox({
  checked,
  onChange,
  label,
  id,
  value,
  ...rest
}) {
  const [isChecked, setIsChecked] = useState(!!checked);

  useEffect(() => {
    setIsChecked(!!checked);
  }, [checked]);

  const handleChange = event => {
    setIsChecked(event.target.checked);
    onChange();
  };

  const renderLabel = () => {
    const matches = label.match(/(.*?)\s*\(([0-9,]+)\)/);
    if (matches) {
      const [, text, count] = matches;
      return (
        <div className={labelWrapper}>
          <span className="label-text">{text}</span>
          <span className={countStyle}>{count}</span>
        </div>
      );
    }
    return <span className="label-text">{label}</span>;
  };

  return (
    <label className={wrapper}>
      <span className={iconWrapper}>
        <input
          checked={isChecked}
          className={input}
          id={id}
          onChange={handleChange}
          type="checkbox"
          value={value}
          {...rest}
        />
        {isChecked ? (
          <CheckedIcon aria-hidden="true" className={icon} focusable="false" />
        ) : (
          <UncheckedIcon
            aria-hidden="true"
            className={icon}
            focusable="false"
          />
        )}
      </span>
      {renderLabel()}
    </label>
  );
}
